// Outlined counterpart to PencilIcon (which is a filled glyph). The design ships a hardcoded
// #021320; this takes the stroke from currentColor instead so it inherits the surrounding text
// color — menu items rely on that, and the disabled state dims with the row.
export default function PencilIconOutline({
  width = 16,
  height = 16,
  stroke = 'currentColor',
  ...rest
}: React.SVGProps<SVGSVGElement>) {
  return (
    <svg xmlns='http://www.w3.org/2000/svg' width={width} height={height} viewBox='0 0 16 16' fill='none' {...rest}>
      <path
        d='M9.51605 2.58325L12.8494 5.91659'
        stroke={stroke}
        strokeWidth='1.16667'
        strokeMiterlimit='10'
        strokeLinecap='square'
      />
      <path
        d='M5.51603 13.2499L0.849365 14.5832L2.1827 9.91654L11.223 0.876205C11.3159 0.783329 11.4261 0.709654 11.5475 0.659389C11.6688 0.609123 11.7989 0.583252 11.9302 0.583252C12.0615 0.583252 12.1916 0.609123 12.3129 0.659389C12.4343 0.709654 12.5445 0.783329 12.6374 0.876205L14.5564 2.79521C14.6492 2.88807 14.7229 2.99831 14.7732 3.11965C14.8234 3.24099 14.8493 3.37104 14.8493 3.50237C14.8493 3.63371 14.8234 3.76376 14.7732 3.88509C14.7229 4.00643 14.6492 4.11668 14.5564 4.20954L5.51603 13.2499Z'
        stroke={stroke}
        strokeWidth='1.16667'
        strokeMiterlimit='10'
        strokeLinecap='square'
      />
    </svg>
  );
}
